import { render } from "./ExampleComponent.vue?vue&type=template&id=18a4b526"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Website\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__